import { createStore } from 'vuex';
import axios from 'axios';
import { HTTP_STATUS_CODES } from '../helpers/config';

const { API_URL } = require('../helpers/config');
const localStorageHelper = require('../helpers/local-storage');

export default createStore({
  state: {
    loggedInUser: null
  },
  mutations: {
    SET_CURRENT_USER(state, loggedInUser) {
      state.loggedInUser = loggedInUser;
    }
  },
  actions: {
    async loginUser({ commit }, { email, password }) {
      try {
        const result = await axios({
          method: 'post',
          url: `${API_URL}/users/login`,
          data: {
            email,
            password
          }
        });
        if (result && result.data && result.status === HTTP_STATUS_CODES.SUCCESS) {
          localStorageHelper.setToken(result.data.id);
          if (result.data.roles.admin) {
            localStorageHelper.setRole('admin');
          }
          result.data.roles.fleetRoles.forEach((fleetRole) => {
            localStorageHelper.setFleetRole(fleetRole.fleetId, fleetRole.role);
          });
          commit('SET_CURRENT_USER', {
            ...result.data,
            email
          });
          return result.body;
        }
      } catch (err) {
      }
    }
  },
  modules: {}
});
